import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// 引入less样式文件
import "./assets/less/index.less";

// 加载接口文件
import api from "./utils/api.js";

// 挂载到vue原型上
const app = createApp(App);

app.use(store).use(router).mount("#app");

app.config.globalProperties.$api = api;
